import React from 'react'

export const Checkbox = ({ checked, className }) => (
  <div className={"cs-pointer " + className}>
    {checked ? <i className="fal fa-check-square fa-lg"></i> : <i className="fal fa-square fa-lg"></i>}
  </div>
)